import { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { motion } from 'framer-motion';

// local imports
import AddPharmacyModal from './add-campaign-pharmacy';
import EditCampaignPharmacy from './edit-campaign-pharmacy';

const initialState = {
  is_all_turp_pharmacies: false,
  pharmacy_ids: []
};

const CampaignPharmacy = ({ setIsSubmitted }) => {
  const history = useHistory();
  const [pharmacyIds, setPharmacyIds] = useState(initialState);
  const { id } = useParams();
  const isEdit = !!id;
  const campaignId = history.location.state?.id || id;
  !isEdit && setIsSubmitted(true);

  // variables - states
  const { is_all_turp_pharmacies, pharmacy_ids } = pharmacyIds;
  const disableSubmitBtn = is_all_turp_pharmacies === false && pharmacy_ids.length < 1;

  return (
    <>
      <motion.div initial={{ scale: 0, opacity: 0.2 }} animate={{ scale: 1, opacity: 1 }}>
        {!isEdit ? (
          <AddPharmacyModal
            campaignId={campaignId}
            confirmBtnDisabled={disableSubmitBtn}
            pharmacyIds={pharmacyIds}
            setPharmacyIds={setPharmacyIds}
          />
        ) : (
          <EditCampaignPharmacy
            campaignId={campaignId}
            pharmacyIds={pharmacyIds}
            setPharmacyIds={setPharmacyIds}
          />
        )}
      </motion.div>
    </>
  );
};

export default CampaignPharmacy;
